// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.034 7.714A5.927 5.927 0 0 1 12 1.75c3.326 0 5.966 2.708 5.966 6 0 3.085-2.469 5.657-5.52 5.897h-.892c-3.086-.206-5.52-2.777-5.52-5.932z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 1.749c3.326 0 5.966 2.708 5.966 5.965 0 3.12-2.435 5.657-5.52 5.897h-.892c-3.051-.205-5.52-2.743-5.52-5.897A5.948 5.948 0 0 1 12 1.75z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.286 12.137c2.914.754 4.868 2.331 4.903 4.114v2.64a3.307 3.307 0 0 1-3.326 3.326H6.137a3.307 3.307 0 0 1-3.325-3.326v-2.64c0-1.783 1.988-3.36 4.902-4.114"
    />
  </svg>
);
export default SvgPerson;
